import React from 'react';
import styled from 'styled-components';
const ContextualHelpContainer = styled.span `
  ${({ theme: { font } }) => `
    font-size: ${font.body.xs.size};
    line-height: ${font.body.xs.lineHeight};
    width: 100%;
  `}
`;
const ContextualHelpNotification = ({ id, className, content, }) => {
    if (!content) {
        return null;
    }
    return (React.createElement(ContextualHelpContainer, Object.assign({}, (id && { id }), { className: className }), content));
};
export { ContextualHelpNotification };
//# sourceMappingURL=ContextualHelpNotification.js.map